import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    Button, Input, Form, Select,
} from 'antd';
import { setLeadsCustomerValuationRequest } from '../../redux/actions/set_customer_valuation.actions';
import { setCustomerNameRequest } from '../../redux/actions/set_customer_name.actions';
import { get, getVal } from '../../../../../shared/helpers';

const mapStateToProps = (state) => {
    const { root_id } = state.Leads.Lead_profile.Lead_general;
    const { loading, customer_valuation, selling_reason } = state.Leads.Lead_profile.Lead_valuations;
    const currentUserId = get(state.App, 'App_content.user._id');
    const { bike_details } = state.Leads.Lead_profile.Ref_bike_lead;
    const { customer_details } = state.Leads.Lead_profile.Ref_lead_customer;

    return {
        root_id, loading, currentUserId, customer_valuation, selling_reason, bike_details, customer_details,
    };
};

export default connect(mapStateToProps, null)(class CustomerWantsModal extends Component {
  state = {
      customerName: '',
      make: '',
      model: '',
      mileage: '',
      vrm: '',
      price: '',
      showOther: false,
      reasonForSelling: '',
      reasonForClosingPopup: '',
      showReasonForSelling: false,
  };

  changePriceCustomerHandler = event => this.setState({ price: event.target.value });

  changeReasonCustomerHandler = event => this.setState({ reasonForSelling: event.target.value });

  changeCustomerName = event => this.setState({ customerName: event.target.value });

  changeCustomerPrice = (event) => {
      event.preventDefault();
      let { reasonForSelling } = this.state;

      if (reasonForSelling === '') {
          if (this.props.selling_reason) {
              reasonForSelling = this.props.selling_reason;
          }
      }

      if (this.state.reasonForClosingPopup && this.state.reasonForClosingPopup !== '') {
          this.props.dispatch(setLeadsCustomerValuationRequest(this.props.root_id, this.state.price, reasonForSelling, this.props.currentUserId, new Date(), this.state.reasonForClosingPopup));
          setTimeout(() => this.props.closeModal(true), 500);
      } else if ((this.state.price === '' || this.state.price === '0') && this.state.reasonForSelling === '') {
          alert('Please enter the customer wants price and reason for selling');
      } else {
          this.props.dispatch(setLeadsCustomerValuationRequest(this.props.root_id, this.state.price, reasonForSelling, this.props.currentUserId, new Date(), this.state.reasonForClosingPopup));
          setTimeout(() => this.props.closeModal(true), 500);
      }
  };

  updateCustomerName = (event) => {
      event.preventDefault();
      this.props.dispatch(setCustomerNameRequest(this.props.customer_details._id, this.state.customerName));
  }

  render() {
      let bikeDetails = '';
      let bike = '';
      if (this.props.bike_details) {
          bikeDetails = this.props.bike_details.vrm;
          bike = this.props.bike_details.experian_name ? this.props.bike_details.experian_name : this.props.bike_details.ref_bike_brand ? (`${this.props.bike_details.ref_bike_brand.name} ${this.props.bike_details.ref_bike_model ? this.props.bike_details.ref_bike_model.name : this.props.bike_details.unmaped_data ? this.props.bike_details.unmaped_data.bike_model : ''}`) : (this.props.bike_details.ref_bike_model ? this.props.bike_details.ref_bike_model.name : this.props.bike_details.unmaped_data ? this.props.bike_details.unmaped_data.bike_model : '');

          if (bikeDetails !== '') {
              bikeDetails += ` - ${bike}`;
          } else {
              bikeDetails = bike;
          }
      }

      return (
          <Fragment>
              <h4 className="bold-text  modal__title" style={{ marginBottom: '4%' }}>Customer Expectations</h4>
              <p>When speaking to the customer, please ask what they are looking for in terms of price for their bike and the reason why they are selling. To close this popup either they need to be filled in or a valid close popup reason needs to be given.</p>

              {this.props.customer_valuation && this.props.customer_valuation !== ''
          && (
              <p>
                  When you last spoke to this customer he wanted
                  <strong>
                      £
                      {this.props.customer_valuation}
                  </strong>
                  {' '}
                  please check if this
                  has changed.
              </p>
          )
              }
              <Form onSubmit={this.changeCustomerPrice}>
                  {this.props.customer_details
            && (
                <Form.Item>
                    <Input
                        disabled={false}
                        placeholder="Customer Name"
                        value={this.state.customerName !== '' ? this.state.customerName : this.props.customer_details ? this.props.customer_details.full_name : ''}
                        onChange={this.changeCustomerName}
                        style={{ width: '80%' }}
                    />
                    <Button
                        loading={this.props.loading}
                        type="primary"
                        disabled={this.state.customerName.length === 0}
                        style={{ marginLeft: 10 }}
                        onClick={this.updateCustomerName}
                    >
                        Update
                    </Button>
                </Form.Item>
            )
                  }
                  {
                      this.props.bike_details
              && (
                  <>
                      <Form.Item>
                          <Input
                              disabled
                              placeholder="VRM"
                              value={bikeDetails}
                          />
                      </Form.Item>
                      <Form.Item>
                          <Input
                              disabled
                              placeholder="Mileage"
                              value={`${this.props.bike_details.mileage} miles`}
                          />
                      </Form.Item>
                  </>
              )
                  }
                  <Form.Item>
                      <Input
                          placeholder="Enter Customer wants price (numbers only)"
                          value={this.state.price}
                          onChange={this.changePriceCustomerHandler}
                      />
                  </Form.Item>
                  <Form.Item>
                      <select value={this.state.reasonForSelling !== '' ? this.props.reasonForSelling : this.props.selling_reason} className="ant-select ant-select-selection" style={{ padding: '8px 5px' }} onChange={e => this.setState({ reasonForSelling: e.target.value, showOther: e.target.value === 'Other' })}>
                          <option>Please select customers reason for selling</option>
                          <option value="Buying a bike">Buying a bike</option>
                          <option value="Financial">Financial</option>
                          <option value="Settle finance and money needed">Settle finance and money needed</option>
                          <option value="Upgrading/part ex">Upgrading/part ex</option>
                          <option value="No longer use">No longer use</option>
                          <option value="Selling on behalf of partner (deceased)">Selling on behalf of partner (deceased)</option>
                          <option value="Buying a car">Buying a car</option>
                          <option value="Buying a house">Buying a house</option>
                          <option value="Just stopping riding and hanging up the leathers">Just stopping riding and hanging up the leathers</option>
                          <option value="Other">Other (If not listed above)</option>
                      </select>
                  </Form.Item>

                  {this.state.showOther
            && (
                <Form.Item>
                    <Input
                        maxLength={500}
                        placeholder="Enter reason for selling"
                        value={this.state.reasonForSelling !== 'Other' ? this.state.reasonForSelling : ''}
                        onChange={this.changeReasonCustomerHandler}
                    />
                </Form.Item>
            )
                  }

                  <Form.Item>
                      <select className="ant-select ant-select-selection" style={{ padding: '8px 5px' }} onChange={e => this.setState({ reasonForClosingPopup: e.target.value })}>
                          <option>Please select reason for closing the popup</option>
                          <option value="Not spoken with customer yet">Not spoken with customer yet</option>
                          <option value="Inside lead to check SMS response">Inside lead to check SMS response</option>
                          <option value="Inside lead to change to DNC">Inside lead to change to DNC</option>
                      </select>
                  </Form.Item>

                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                      <Button
                          loading={this.props.loading}
                          type="primary"
                          style={{ marginLeft: 10 }}
                          onClick={this.changeCustomerPrice}
                      >
                          Update Price Expectation
                      </Button>
                  </div>
              </Form>
          </Fragment>
      );
  }
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/CustomerWantsModal.js